export default __webpack_public_path__ + "static/media/img_03.66c16508.webp";